import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const DataIntegrityCheckList = () => {
  const columns = [
    { label: 'Model Name', value: 'model_name' },
    { label: 'Record ID', value: 'record_id' },
    { label: 'Last Verified', value: 'last_verified' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/security/data-integrity/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['dataIntegrityCheck']} />;
};

export default DataIntegrityCheckList;